<ion-header>
	<ion-toolbar *ngIf="!isLoading" mode="md">
		<ion-buttons slot="end">
			<ion-button (click)="onClickOpenFilter()">
				<ion-icon name="filter-outline"></ion-icon>
			</ion-button>
		</ion-buttons>
		<ion-title class="ion-text-center" mode="md">
			{{ inventoryList?.length || 0 }} Inventory Found
		</ion-title>
	</ion-toolbar>
</ion-header>

<ion-content>
	<ng-container *ngIf="!isLoading; else loading">
		<ng-container *ngIf="inventoryList?.length > 0; else empty">
			<ion-item-group
				*ngFor="let item of inventoryList; index as index"
				mode="md"
			>
				<ion-item
					lines="full"
					button
					(click)="onClickToggleSection(index)"
					mode="md"
				>
					<ion-buttons slot="end">
						<ion-button>
							<ion-icon
								class="toggle-arrow"
								[name]="
									isVisible(index)
										? 'chevron-up-outline'
										: 'chevron-down-outline'
								"
							></ion-icon>
						</ion-button>
					</ion-buttons>
					<div class="item__meta">
						<div class="item__heading">
							<ion-text
								*ngIf="item.categoryDesc"
								class="item__category"
							>
								<strong>{{ item.categoryDesc }}</strong>
							</ion-text>
							<ion-text
								*ngIf="item.equipName"
								class="item__equipment"
							>
								<strong *ngIf="item.categoryDesc"
									>: &nbsp;</strong
								>
								<strong>{{ item.equipName }}</strong>
							</ion-text>
						</div>
						<div
							*ngIf="item.attributes[0] as primAttr"
							class="item__primary"
						>
							{{ primAttr.name }}: {{ primAttr.value || "N/A" }}
						</div>
					</div>
				</ion-item>
				<ion-item
					lines="full"
					*ngIf="isVisible(index)"
					color="light"
					mode="md"
				>
					<ion-grid mode="md">
						<ion-row>
							<ion-col size="6">
								<ion-label>Status:</ion-label>
							</ion-col>
							<ion-col size="6">{{ item.status }}</ion-col>
						</ion-row>
						<ion-row *ngFor="let attr of item.attributes.slice(1)">
							<ion-col size="6">
								<ion-label>{{ attr.name }}:</ion-label>
							</ion-col>
							<ion-col size="6">
								<ion-label>{{ attr.value }}</ion-label>
							</ion-col>
						</ion-row>
						<ion-row>
							<ion-col size="6">
								<ion-label>ID:</ion-label>
							</ion-col>
							<ion-col size="6">{{ item.id }}</ion-col>
						</ion-row>
					</ion-grid>
				</ion-item>
			</ion-item-group>
		</ng-container>
		<ng-template #empty>
			<app-empty-list-item
				[message]="'No Inventory'"
			></app-empty-list-item>
		</ng-template>
	</ng-container>

	<ng-template #loading>
		<app-loader [message]="'Fetching Inventory'"></app-loader>
	</ng-template>
</ion-content>
